import React from "react";
import Inscription from "@/components/Inscription/InscriptionComponent";
import { TypeUser } from "@/types/UtilisateurType";
import { INSCRIPTION_DATA } from "@/constants/data";
import { configFormulaire } from "@/config/configFormulaire";
import { useVilles } from "@/hooks/useVilles";
import { useSearchParams } from "react-router-dom";
import ContactComponent from "@/components/Formulairecontact/ContactComponent";

export default function InscriptionPage() {
  const { villes } = useVilles();
  const [searchParams] = useSearchParams();
  const queryEmail = searchParams.get("email") || "";
  const queryName = searchParams.get("name") || "";

  return (
    <div className="pt-2">
      <div className="text-center">
        <p className="text-lg italic text-[#000080]">
          Rejoignez la plateforme de recensement du cheptel sénégalais
        </p>
        <p className="text-xl font-bold text-gray-900 mt-1">
          Digitalisez votre élevage et accédez à des données fiables
        </p>
      </div>
      <Inscription
        typeUsers={[TypeUser.PARTICULIER, TypeUser.ENTREPRISE]}
        title={INSCRIPTION_DATA.title}
        description={INSCRIPTION_DATA.description}
        advantages={INSCRIPTION_DATA.advantages}
        images={INSCRIPTION_DATA.images}
        isDisplayConditions={true}
        villes={villes}
        configFormulaire={configFormulaire}
        initialValues={{ email: queryEmail || "", nom: queryName || "" }}
      />
      <ContactComponent />
    </div>
  );
}
